import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LogOut } from "../../../Redux/authSlice";
import { setLoaderFalse, setLogoutLoading } from "../../../Redux/loaderSlice";
import { Button } from "primereact/button";
import { Modal } from "react-bootstrap";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useGetNotificationListQuery } from "../../../rtk-query/features/usernotification/notificationRTK";
import { useSubscription } from "../../../hooks/useSubscription";
import { PRIVILEGES } from "../../../utils/privileges";

const RecursiveCall = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { hasSubscription } = useSubscription();
  const authReducer = useSelector((state) => state.authReducer);
  const [isPrompted, setIsPrompted] = useState(false);
  const [visible, setVisible] = useState(false);

  const [notificationAPICalled, setNotificationAPICalled] = useState(false);
  const { refetch } = useGetNotificationListQuery(_, {
    skip: !hasSubscription(PRIVILEGES.SHOW_BANNER_NOTIFICATION),
  });

  useEffect(() => {
    const interval = setInterval(() => {
      if (
        moment(authReducer?.expirationTime).diff(moment(), "seconds") < 0 &&
        !isPrompted
      ) {
        setVisible(true);
        setIsPrompted(true);
      }

      if (
        moment(moment()).diff(authReducer?.loggedInTime, "minutes") % 20 ===
        0
      ) {
        if (
          !notificationAPICalled &&
          hasSubscription(PRIVILEGES.SHOW_BANNER_NOTIFICATION)
        ) {
          refetch();
          setNotificationAPICalled(true);
        }
      } else {
        setNotificationAPICalled(false);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  });

  return (
    <>
      {/* Testing session timeout */}
      <div className="card flex justify-content-center">
        <Modal
          className="emailCampaignPagePopup"
          show={visible}
          onHide={() => {
            if (!visible) return;
            setVisible(false);
            dispatch(setLogoutLoading(true));
            dispatch(LogOut());
          }}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header className="px-6 pt-6 border-bottom-0">
            <h5 className="modal-title custompopup blockTitle mb-4">
              Session Timeout
            </h5>
          </Modal.Header>

          <Modal.Body className="px-6 pt-0">
            <p className="m-0 mb-10">
              Your session has expired. Please log in to continue where you left
              off.
            </p>
            <Button
              label="OK"
              className="rounded"
              onClick={async () => {
                setVisible(false);
                dispatch(setLogoutLoading(true));
                await dispatch(LogOut())
                  .unwrap()
                  .then(() => {
                    dispatch(setLoaderFalse());
                    navigate("/user/login");
                  })
                  .catch((err) => {
                    dispatch(setLoaderFalse());
                  });
              }}
            />
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export default RecursiveCall;
